<template>
  <b-form @submit="onSubmit">
    <b-form-group>
      <b-row>
        <b-col>
          <h2>{{ $t('privatePage.testdata_select_testmethods') }}</h2>
          <b-form-checkbox-group stacked
                                  id="testMethodsGroup"
                                  name="testMethods"
                                  v-model="selectedTestMethods"
                                  :options="testMethods">
          </b-form-checkbox-group>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <h2>{{ $t('privatePage.testdata_date_filter') }}</h2>
      <b-row>
        <b-col sm="4">
          <label for="input-start_date">{{ $t('privatePage.testdata_start_date') }}</label>
          <b-form-input id="input-start_date"
                        type="date"
                        v-model="startDate" />
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col sm="4">
          <label for="input-end_date">{{ $t('privatePage.testdata_end_date') }}</label>
          <b-form-input id="input-end_date"
                        type="date"
                        v-model="endDate" />
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col>
            <b-button type="submit">{{ $t('privatePage.testdata_export') }}</b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </b-form>
</template>

<script>
let date = new Date()
date.setDate(date.getDate())
let endDateString = date.toLocaleDateString('sv-SE')

date.setFullYear(date.getFullYear() - 1)
let startDateString = date.toLocaleDateString('sv-SE')

export default {
  name: 'test-data-export-editor',
  props: {
    testMethods: {}
  },
  data() {
    return {
      selectedTestMethods: [],
      startDate: startDateString,
      endDate: endDateString
    }
  },
  methods: {
    onSubmit: function(evt) {
      evt.preventDefault()
      this.$emit('onSubmit', {
        testMethodIds: this.selectedTestMethods,
        startDate: this.startDate,
        endDate: this.endDate
      })
    }
  }
}

</script>
